import type { InputHTMLAttributes } from 'react';

export function Field({ label, error, id, ...rest }: InputHTMLAttributes<HTMLInputElement> & { label: string; error?: string; id: string }) {
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <input id={id} aria-invalid={!!error} aria-describedby={error ? `${id}-err` : undefined} {...rest} />
      {error && <span className="field-error" id={`${id}-err`}>{error}</span>}
    </div>
  );
}
